// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2kGYr","title":"BackImages_title__2B4QP","images":"BackImages_images__3I1ya"};